var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShapeLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163.329,
    height: 114.611,
    viewBox: "0 0 163.329 114.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5661 2627.61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.323,19.917,23.208,0l.346,95.6L0,119.152Z",
    transform: "translate(5807.673 -2627.61) rotate(45)",
    fill: "#1a418a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.323,19.917,23.208,0l.346,95.6L0,119.152Z",
    transform: "translate(5745.253 -2613.908) rotate(45)",
    fill: "#b4b2e7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeLines);
export default __webpack_public_path__ + "static/media/shape-Lines.1f3de83abb44ff67c88272fd974c2867.svg";
export { ForwardRef as ReactComponent };